import React, { Component } from 'react';
import Header from '../common/Header';
import Sidebar from '../common/Sidebar';
import MobileNotification from '../common/MobileNotification';
import Schedule from '../common/Schedule';
import Gmaps from '../common/Gmaps';
import JobHistoryList from './JobHistoryList';
import JobSliderView from '../JobSliderView/JobSliderView';
// import {heatMapData} from '../../constants/staticData.js';
import SortBy from '../Results/SortBy';
import FilterBy from '../Results/FilterBy';
import { capitalize, cloneDeep } from 'lodash';
import PageLoader from '../common/PageLoader';
import { queryStringtoArray } from '../../helpers/index';
import { imageBasePath } from '../../constants/staticData';
import InfiniteScroll from 'react-infinite-scroller';
import MobileHeaderSearch from '../common/MobileHeaderSearch';

export default class JobHistory extends Component {
  constructor(props, context) {
    super(props, context);
    this.toggleNotification = this.toggleNotification.bind(this);
    const jobType = queryStringtoArray('job_type');
    const selectedJobState = (jobType && (jobType == 'completed' || jobType == 'decline' || jobType == 'expired' || jobType == 'closed')) ? capitalize(jobType) : 'All';
    this.isFetchingData = false;
    this.state = {
      searchMobile: false,
      'sortKey': 'sortby=-date',
      'filterParameters': false,
      'selectedJobState': selectedJobState,
      'isHistoryLoading': (props.jobRequestReducer && props.jobRequestReducer.jobHistory && props.jobRequestReducer.jobHistory.length) ? false : true,
      'setCenter': false,
      'latlng': {
        lat: 37.775,
        lng: -122.434
      },
      'heatmapVisible': false,
      'showJobSlider': false,
      'currentSliderId': 0,
      vat: 0,
      'filteredJobHistory': undefined,
      'jobStatus': undefined
    };
    this.sortChanged = this.sortChanged.bind(this);
    this.filterApplied = this.filterApplied.bind(this);
  }

  componentWillMount() {
    this.props.actions.getJobHistory('history', 10, 0, false, 'sortby=-date', this.state.filterParameters);
    this.props.actions.getBusinessTax();

  }
  // componentDidMount() {
  //   let selectedJob = this.props.routeParams.jobStatus;
  //   if(selectedJob){
  //     this.setState({selectedJobState:selectedJob});
  //   }
  // }



  toggleNotification(isVisible) {
    this.setState({ 'notificationVisible': isVisible });
  }
  hclickCallBack() {
    this.setState({ showSidebar: !this.state.showSidebar })
  }
  listDropdown() {
    this.setState({ dropdownIcon: !this.state.dropdownIcon });
  }
  statusList(list) {
    this.setState({ selectedList: list });
  }
  componentWillReceiveProps(nextProps) {
    this.isFetchingData = false;
    if (this.state.isHistoryLoading && nextProps.jobRequestReducer && nextProps.jobRequestReducer.isJobHistoryLoaded) {
      this.setState({ 'isHistoryLoading': false });
    }
    this.setState({

      vat:  nextProps.commonReducer && nextProps.commonReducer.taxInfo &&  nextProps.commonReducer.taxInfo.length && nextProps.commonReducer.taxInfo ?  nextProps.commonReducer.taxInfo[0].value: 0,
    })
  }

  filterApplied(requestType, queryParams, filterState) {
    this.setState({ filterParameters: queryParams });
    let updatedFilterState = cloneDeep(filterState);
    updatedFilterState.filterParams = queryParams;
    updatedFilterState.fiterBy = false;
    this.props.actions.openJobsFilterChanged(updatedFilterState, 'jobhistory');
    this.props.actions.getJobHistory(requestType, 10, 0, false, this.state.sortKey, queryParams);
  }

  sortChanged(requestType, selectedOption, sortState) {
    let sortKey = this.state.sortKey;
    if (selectedOption == "Nearest First") {
      sortKey = 'sortby=-distance';
    } else if (selectedOption == "Farthest First") {
      sortKey = 'sortby=distance';
    } else if (selectedOption == "Newest to Oldest") {
      sortKey = 'sortby=-date';
    } else if (selectedOption == "Oldest to Newest") {
      sortKey = 'sortby=date';
    }
    this.props.actions.getJobHistory(requestType, 10, 0, false, sortKey, this.state.filterParameters);
    let updatedSortState = cloneDeep(sortState);
    updatedSortState.sortByText = selectedOption;
    updatedSortState.sortBy = false;
    this.props.actions.openJobsFilterChanged(updatedSortState, 'jobhistory', true);
    this.setState({ sortKey: sortKey });
  }

  render() {
    const {
      jobRequestReducer, actions
    } = this.props;

    let jobHistory = [];
    let jobHistoryLoaded = false;
    let totalCount = 0;
    let requestType = 'history';
    switch (this.state.selectedJobState) {
      case 'All': {
        jobHistory = jobRequestReducer.jobHistoryList && jobRequestReducer.jobHistoryList.allJobHistory;
        jobHistoryLoaded = jobRequestReducer.allJobsLoaded;
        totalCount = jobRequestReducer.pageInfo ? jobRequestReducer.pageInfo.jobHistoryTotalCount : 0;
        requestType = 'history';
        break;
      }
      case 'Completed': {
        jobHistory = jobRequestReducer.jobHistoryList && jobRequestReducer.jobHistoryList.completedJobs;
        jobHistoryLoaded = jobRequestReducer.completedJobsLoaded;
        totalCount = jobRequestReducer.pageInfo ? jobRequestReducer.pageInfo.completedJobsTotalCount : 0;
        requestType = 7;
        break;
      }
      case 'Decline': {
        jobHistory = jobRequestReducer.jobHistoryList && jobRequestReducer.jobHistoryList.declinedJobs;
        jobHistoryLoaded = jobRequestReducer.declinedJobsLoaded;
        totalCount = jobRequestReducer.pageInfo ? jobRequestReducer.pageInfo.declinedJobsTotalCount : 0;
        requestType = 5;
        break;
      }
      case 'Expired': {
        jobHistory = jobRequestReducer.jobHistoryList && jobRequestReducer.jobHistoryList.expiredJobs;
        jobHistoryLoaded = jobRequestReducer.expiredJobsLoaded;
        totalCount = jobRequestReducer.pageInfo ? jobRequestReducer.pageInfo.expiredJobsTotalCount : 0;
        requestType = 8;
        break;
      }
      case 'Closed': {
        jobHistory = jobRequestReducer.jobHistoryList && jobRequestReducer.jobHistoryList.closedJobs;
        jobHistoryLoaded = jobRequestReducer.closedJobsLoaded;
        totalCount = jobRequestReducer.pageInfo ? jobRequestReducer.pageInfo.closedJobsTotalCount : 0;
        requestType = 'closed';
        break;
      }
    }

    console.log("jobRequestReducer.jobHistoryList",jobRequestReducer.jobHistoryList)
    return (
      <div>
        {/*Header*/}
        <Header searchMobile={this.state.searchMobile} hideOption={() => this.setState({ searchMobile: true })} commonReducer={this.props.commonReducer} actions={this.props.actions} notificationCount={2} profileName="Derrick Frank" notificationCallBack={this.toggleNotification} authReducer={this.props.authReducer}
                hCallback={() => { this.hclickCallBack() }} router={this.props.router} />
        <MobileNotification isVisible={this.state.notificationVisible} backBtnCallBack={this.toggleNotification} />
        <div className="main-wrapper">
          {/*Sidebar*/}
          <Sidebar showSidebar={this.state.showSidebar} router={this.props.router} actions={this.props.actions} commonReducer={this.props.commonReducer} authReducer={this.props.authReducer} />
          <div className="container-fluid main-container">
            <div className="col-md-9 mpad0 padr30 job-history">
              {this.state.isHistoryLoading
                ? (<PageLoader />)
                : (jobHistoryLoaded || jobRequestReducer.jobHistoryList && jobRequestReducer.jobHistoryList.allJobHistory && jobRequestReducer.jobHistoryList.allJobHistory.length)
                  ?
                  (<div>
                    <div className="ov-heading">
                      <h5>Job History</h5>
                      <div className="text-dropdown statusList-dropdown">
                        <h4 className="oj-title">{this.state.selectedList}</h4>
                      </div>
                      <div className="filter-section">
                        <SortBy sortCallback={this.sortChanged.bind(this, requestType)} mapVisible={() => this.setState({ heatmapVisible: false })} sortState={jobRequestReducer.openJobsFilters && jobRequestReducer.openJobsFilters.jobhistory && jobRequestReducer.openJobsFilters.jobhistory.sort} />
                        <FilterBy actions={actions} jobRequestReducer={jobRequestReducer} filterApplied={this.filterApplied.bind(this, requestType)} mapVisible={() => this.setState({ heatmapVisible: false })} filterState={jobRequestReducer.openJobsFilters && jobRequestReducer.openJobsFilters.jobhistory.filter} />
                        <span className={this.state.heatmapVisible ? "map-icon map-visible" : "map-icon"} onClick={() => this.setState({ heatmapVisible: !this.state.heatmapVisible })}>
                          <a >
                            <i className="mdi mdi-map" />
                            <label>Map</label>
                          </a>
                        </span>
                      </div>
                    </div>
                    <div className="content-view">
                      <div className={this.state.heatmapVisible ? "sub-header map-visible" : "sub-header"}>
                        {/* {this.state.heatmapVisible && <Gmaps
                                setCenter={this.state.setCenter}
                                center={this.state.latlng}
                                zoom={9}
                                containerElement={<div style={{ height: 210 + 'px', width: 'auto' }} />}
                                mapElement={<div style={{ height: 210 + 'px', width: 'auto' }} />}
                                heatMapData={heatMapData}
                            />} */}
                        <ul>
                          <li className={this.state.selectedJobState == 'All' ? "active" : ""} onClick={() => {
                            this.setState({ selectedJobState: "All" });
                            this.state.selectedJobState != 'All' && this.props.actions.getJobHistory('history', 10, 0, false, this.state.sortKey, this.state.filterParameters);
                          }}>All</li>
                          <li className={this.state.selectedJobState == 'Closed' ? "active" : ""} onClick={() => {
                            this.setState({ selectedJobState: "Closed" });
                            this.state.selectedJobState != 'Closed' && this.props.actions.getJobHistory('closed', 10, 0, false, this.state.sortKey, this.state.filterParameters);
                          }}>Closed</li>
                          <li className={this.state.selectedJobState == 'Decline' ? "active" : ""} onClick={() => {
                            this.setState({ selectedJobState: "Decline" });
                            this.state.selectedJobState != 'Decline' && this.props.actions.getJobHistory(5, 10, 0, false, this.state.sortKey, this.state.filterParameters);
                          }}>Declined</li>
                          <li className={this.state.selectedJobState == 'Expired' ? "active" : ""} onClick={() => {
                            this.setState({ selectedJobState: "Expired" });
                            this.state.selectedJobState != 'Expired' && this.props.actions.getJobHistory(8, 10, 0, false, this.state.sortKey, this.state.filterParameters);
                          }}>Expired</li>
                          {/*   <li className={this.state.selectedJobState == 'Closed' ? "active" : ""} onClick={() => {
                            this.setState({ selectedJobState: "Closed" });
                            this.state.selectedJobState != 'Closed' && this.props.actions.getJobHistory('closed', 10, 0, false, this.state.sortKey, this.state.filterParameters);
                          }}>Closed</li>*/}

                        </ul>
                      </div>
                      {jobHistoryLoaded ?
                        <InfiniteScroll
                          pageStart={0}
                          loadMore={() => {
                            if (!this.isFetchingData) {
                              this.isFetchingData = true;
                              this.props.actions.getJobHistory(requestType, 10, jobHistory.length, true, this.state.sortKey, this.state.filterParameters);
                            }
                          }}
                          hasMore={jobHistory.length < totalCount}
                          loader={<PageLoader />}>
                          <JobHistoryList
                            router={this.props.router}
                            onCardClick={(currentSliderId, filteredJobHistory, jobStatus) =>
                            {
                              this.setState(
                                { 'showJobSlider': true,
                                  'currentSliderId': currentSliderId,
                                  'filteredJobHistory': filteredJobHistory,
                                  'jobStatus': jobStatus
                                })
                            }
                            }
                            jobHistory={
                              jobHistory && jobHistory
                            }
                            vat={this.state.vat}
                            fromJobHistory={true}
                            selectedJobState={this.state.selectedJobState} />
                        </InfiniteScroll>
                        : <PageLoader />}
                    </div>
                  </div>)
                  : jobRequestReducer.unableToFetchJobHistory
                    ? (<div style={{ 'height': "400px", 'textAlign': 'center', 'paddingTop': '40px' }}><div className="sliderHeader"><div className="slider-btn-right"><span className="jobSlider-close" onClick={this.props.modalCloseCallBack}><i className="mdi mdi-close" /></span></div></div><h3>Unable to fetch history <a style={{ cursor: 'pointer' }} onClick={(e) => { e.preventDefault; this.props.actions.getJobHistory('history', 10, 0, false, 'sortby=-date', this.state.filterParameters); }}>Try Again</a></h3></div>)
                    : (<div><div className="ov-heading"> <h5>Job History</h5> </div><div className="content-view"><div className="empty-state-holder"><span className="empty-state-content"><img src={`${imageBasePath}/request_empty.png`} /><span>Oops! Looks like you don’t have any Jobs. </span></span></div></div></div>)
              }
            </div>
            {this.state.showJobSlider && <JobSliderView
              jobRequestReducer={this.props.jobRequestReducer}
              commonReducer={this.props.commonReducer}
              jobs={this.state.filteredJobHistory}
              actions={this.props.actions}
              currentSliderId={this.state.currentSliderId}
              fromJobHistory={true}
              jobStatus={this.state.jobStatus}
              router={this.props.router}
              modalCloseCallBack={(e) => { e.preventDefault(); this.setState({ 'showJobSlider': false }); }} />}
            <div className="col-md-3 mpad0 padLeft0">
              <Schedule commonReducer={this.props.commonReducer} router={this.props.router} />
            </div>
          </div>
        </div>
        {this.state.searchMobile && <div >

          <MobileHeaderSearch mobile={true} actions={this.props.actions} commonReducer={this.props.commonReducer} mobSearchClick={() => this.setState({ searchMobile: false })} />
        </div>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/JobHistory/JobHistory.jsx